import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../../../../types/upload-field'
import UsernameField from '../../../../../form-fields/upload/username'
import { CreationCaptureInfoContext } from '../manager'

const Username = styled(UsernameField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolUploadField
}

const CreationCaptureInfoUsernameField = ({ field }: Props) => {
    const { username, setUsername } = useContext(CreationCaptureInfoContext)

    return (
        <Username
            {...{
                field,
                username,
                onChange: setUsername,
            }}
        />
    )
}

export default CreationCaptureInfoUsernameField
